import { defaultIconProps } from 'components/common/icons'
import type { DefaultIconProps } from 'components/common/icons'

export const Bookshelf = ({
  size = defaultIconProps.size,
  className = defaultIconProps.className,
}: DefaultIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 88C4 85.7908 5.79088 84 8 84H88C90.2092 84 92 85.7908 92 88C92 90.2092 90.2092 92 88 92H8C5.79088 92 4 90.2092 4 88Z"
      fill="#606880"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.7276 45.0894C66.3348 45.491 67.3124 47.1198 66.9104 48.7274L62.9104 64.7274C62.5084 66.3346 60.8796 67.3122 59.2724 66.9102C57.6652 66.5082 56.6876 64.8794 57.0896 63.2722L61.0896 47.2722C61.4916 45.6646 63.1204 44.6874 64.7276 45.0894ZM52 44.9998C53.6568 44.9998 55 46.343 55 47.9998V63.9998C55 65.6566 53.6568 66.9998 52 66.9998C50.3432 66.9998 49 65.6566 49 63.9998V47.9998C49 46.343 50.3432 44.9998 52 44.9998ZM72 44.9998C73.6568 44.9998 75 46.343 75 47.9998V63.9998C75 65.6566 73.6568 66.9998 72 66.9998C70.3432 66.9998 69 65.6566 69 63.9998V47.9998C69 46.343 70.3432 44.9998 72 44.9998Z"
      fill="#606880"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.034 4.47121C69.3212 3.99981 64.6184 3.99989 58.8596 4H37.1406C31.3817 3.99989 26.6787 3.99981 22.9662 4.47121C19.1027 4.96177 15.7098 6.02385 12.975 8.60669C10.208 11.22 9.03964 14.5144 8.50516 18.269C7.99976 21.8192 7.99988 26.2992 8 31.7035L8.00004 88C8.00004 90.2092 9.79092 92 12 92H84C86.2092 92 88 90.2092 88 88V31.7041C88.0004 26.2995 88.0004 21.8193 87.4948 18.269C86.9604 14.5144 85.792 11.22 83.0252 8.60669C80.2904 6.02385 76.8976 4.96177 73.034 4.47121ZM80 58.6C80 59.7312 80 60.2972 79.6484 60.6484C79.2972 61 78.7316 61 77.6 61H18.4C17.2686 61 16.703 61 16.3515 60.6484C16 60.2972 16 59.7312 16 58.6V41.4C16 40.2688 16 39.7029 16.3515 39.3515C16.703 39 17.2686 39 18.4 39H77.6C78.7316 39 79.2972 39 79.6484 39.3515C80 39.7029 80 40.2688 80 41.4V58.6ZM41 76C41 74.3432 42.3432 73 44 73H52C53.6568 73 55 74.3432 55 76C55 77.6568 53.6568 79 52 79H44C42.3432 79 41 77.6568 41 76ZM35.2724 17.0903C36.8798 16.6885 38.5086 17.6657 38.9104 19.2731L42.3424 33.001H36.1578L33.0896 20.7283C32.6877 19.1209 33.665 17.4921 35.2724 17.0903ZM51 33.001H45V20.0007C45 18.3439 46.3432 17.0007 48 17.0007C49.6568 17.0007 51 18.3439 51 20.0007V33.001ZM29 33.001H23V20.0007C23 18.3439 24.3432 17.0007 26 17.0007C27.6568 17.0007 29 18.3439 29 20.0007V33.001Z"
      fill="#606880"
    />
  </svg>
)
